export const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24;
export const FOUR_HOURS_IN_MS = 1000 * 60 * 60 * 4;
export const THREE_HOURS_IN_MS = 1000 * 60 * 60 * 3;
export const TWO_HOURS_IN_MS = 1000 * 60 * 60 * 2;
export const ONE_HOUR_IN_MS = 1000 * 60 * 60;
export const THIRTY_MINUTES_IN_MS = 1000 * 60 * 30;
export const FIFTEEN_MINUTES_IN_MS = 1000 * 60 * 15;
export const FIVE_MINUTES_IN_MS = 1000 * 60 * 5;

export const QUERY_CLIENT_PREFIX = "bc-checkout-shop-app-cache";
